let Environment = {
  // backendUrl: "api.Elinnovation.net/", //staging url
  backendUrl: "https://api.Elinnovation.net/", //production url
  // backendUrl : "http://192.168.30.134:9000/admin",    // local backend URL
};

export default Environment;